export default __webpack_public_path__ + "static/media/plus.9897daec.svg";